module.exports = __webpack_public_path__ + "static/img/2-5.ce2eddc8.png";